import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Paper, Typography, Box } from '@mui/material';
import {
  Input as InputIcon,
  Transform as TransformIcon,
  Psychology as AiIcon,
  Code as CodeIcon,
  Output as OutputIcon,
} from '@mui/icons-material';
import { MODULE_TYPES } from '../../utils/constants';

const getNodeIcon = (type) => {
  switch (type) {
    case MODULE_TYPES.INPUT:
      return <InputIcon fontSize="small" />;
    case MODULE_TYPES.TRANSFORM:
      return <TransformIcon fontSize="small" />;
    case MODULE_TYPES.AI_ENRICHMENT:
      return <AiIcon fontSize="small" />;
    case MODULE_TYPES.CUSTOM_CODE:
      return <CodeIcon fontSize="small" />;
    case MODULE_TYPES.OUTPUT:
      return <OutputIcon fontSize="small" />;
    default:
      return null;
  }
};

const CustomNode = ({ data, isConnectable, selected }) => {
  const nodeColors = data.nodeColors || {
    background: '#f5f5f5',
    border: '#ccc',
    text: '#333',
  };

  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        padding: 1,
        minWidth: 180,
        borderRadius: 1,
        border: selected ? `2px solid ${nodeColors.border}` : `1px solid ${nodeColors.border}`,
        backgroundColor: nodeColors.background,
        color: nodeColors.text,
        transition: 'all 0.2s ease-in-out',
      }}
    >
      {/* Input handle for all except input nodes */}
      {data.type !== MODULE_TYPES.INPUT && (
        <Handle
          type="target"
          position={Position.Left}
          style={{ background: nodeColors.border, borderRadius: '50%' }}
          isConnectable={isConnectable}
        />
      )}

      {/* Node content */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
        <Box sx={{ mr: 1 }}>{getNodeIcon(data.type)}</Box>
        <Typography variant="body1" fontWeight="medium" noWrap>
          {data.label}
        </Typography>
      </Box>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {data.module}
      </Typography>

      {/* Output handle for all except output nodes */}
      {data.type !== MODULE_TYPES.OUTPUT && (
        <Handle
          type="source"
          position={Position.Right}
          style={{ background: nodeColors.border, borderRadius: '50%' }}
          isConnectable={isConnectable}
        />
      )}
    </Paper>
  );
};

export default memo(CustomNode);
